import axios from 'axios';

const get = () => axios.get('/alcadas/compras');

const create = data => axios.post('/alcadas/compras', data);

const update = (id, data) => axios.put(`/alcadas/compras/${id}`, data);

const remove = id => axios.delete(`/alcadas/compras/${id}`);

export default {
  get,
  create,
  update,
  remove,
};
